<template>
  <div>
    <div ref="modal" style="display: none">

      <div class="mb-3">
        <b>Добавление приложения</b>
      </div>

      <mobile-app-form-block
          ref="form"
          :id="id"
          :defaultParams="defaultParams"
          @save="update"
          @add="update"
          @cancel="fancyboxClose"
      />

    </div>
  </div>

</template>

<script>

import MobileAppFormBlock from "@/views/MobileApp/MobileAppFormBlock";

export default {
  components: {MobileAppFormBlock},
  data() {
    return {
      id: null,
    }
  },
  props: {
    defaultParams: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    openModal(data_id) {
      this.id = data_id
      setTimeout(() => {
        this.$refs.form.init();
        this.fancybox(this.$refs.modal)
      }, 0)
    },
    update() {
      this.$emit('update')
      this.fancyboxClose()
    },
  },
}
</script>